export enum ZIndex {
  DevTools = 9999999,
  PageLayoutHeader = 99999,
  PageLayoutBanner = 99999,
  PageLayoutFooter = 99999,
  PageLayoutSubHeader = 9999,
  PageLayoutContentTopBar = 9999,
  PageLayoutCollapsiblePanel = 9999,
  PageLayoutContentColumn = 999,
  SingleColumnLayoutHeader = 99999,
  SingleColumnLayoutBanner = 99999,
  SingleColumnLayoutFooter = 99999,
}
